<template>
  <button :disabled="!isSupported" @click="onClick()" class="w-6 h-6 flex items-center justify-center p-0 rounded-full border border-black/20">
    <pe-icon icon="colorize" />
  </button>
</template>

<script setup lang="ts">
import { useEyeDropper } from '@vueuse/core'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const { isSupported, open } = useEyeDropper({
  initialValue: props.modelValue
})

const onClick = () => {
  open().then((val) => {
    emit('update:modelValue', val.sRGBHex)
  }).catch(() => {
    //
  })
}
</script>
